import MessageBox from 'components/commons/MessageBox/MessageBox';
import { FormattedText } from 'core/i18n';
import React from 'react';

export const ContinueWithoutTransferAdvise = () => {
    return (
        <MessageBox
            contentText={<FormattedText value="identification-continueWithoutTransferAdvise" />}
            boxColor={'blue'}
            iconColor={'info-blue'}
        />
    );
};
